import { useEffect, useState, lazy } from 'react';
import Homepage from './pages/Homepage/Homepage';
import { Routes, Route, Outlet } from 'react-router-dom';
import Login from './pages/Auth/Login';
import Signup from './pages/Auth/Signup';
import Contact from './pages/Contact/Contact';
import About from './pages/About/About';
import Menu from './pages/Menu/Menu';
import Cart from './pages/Cart/Cart';
import UserSetting from './pages/UserSetting/UserSetting';
// import { useSelector } from 'react-redux';

import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import * as Action from './store/actions/index';
import { AlertMsg } from './component/Alert/Alert';
import Users from './pages/Admin/Users/Users';
import Products from './pages/Admin/Products/Products';
import Overview from './pages/Admin/Overview/Overview';
import Layout from './component/Layout';
import Reservations from './pages/Admin/Reservations/Reservations';
import Order from './pages/Admin/Order/Order';
import EditProduct from './pages/Admin/Products/EditProduct/EditProduct';
import ViewProduct from './pages/Admin/Products/ViewProduct/ViewProduct';
import AddProduct from './pages/Admin/Products/AddProduct/AddProduct';
import Settings from './pages/Admin/Settings/Settings';
import EditUser from './pages/Admin/Users/EditUser/EditUser';
import { axiosInstance as axios } from './axios/axios';
import Backdrop from './component/Backdrop';
import Loader from './component/UI/Loader/Loader';
import Main from './component/Menu/Main/Main';
import CategoryView from './component/Menu/CategoryView/CategoryView';
import ViewUser from './pages/Admin/Users/ViewUser/ViewUser';
import LazyComponent from './component/LazyComponent/LazyComponent';
import { token } from './store/actionCreators';
import { isAdmin } from './utils/checkAdmin';
import OrderDetails from './pages/OrderDetails/OrderDetails';
import Checkout from './pages/Checkout/Checkout';
import { localStorageFunc } from './utils/localStorage';

const Admin = lazy(() => import('./pages/Admin/Admin'));

function App() {
  const alert = useAlert();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) return;
    (async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `/api/auto-login?token=${token}`);
        const userData = res.data.data;
        dispatch({ type: Action.LOGIN, payload: { token, user: userData } });
      } catch (err) {}
      setLoading(false);
    })();
  }, []);

  // DISPLAY ALERT
  useEffect(() => {
    if (state.error.errorMsg) {
      if (state.error.type === 'success') {
        alert.success(<AlertMsg>{state.error.errorMsg}</AlertMsg>, {
          onClose: () => {
            dispatch({ type: Action.HIDE_ERROR });
          },
        });
      } else if (state.error.type === 'error') {
        alert.error(<AlertMsg>{state.error.errorMsg}</AlertMsg>, {
          onClose: () => {
            dispatch({ type: Action.HIDE_ERROR });
          },
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.error.errorMsg]);

  // CHECK FOR CART ITEMS IN LOCALSTORAGE
  useEffect(() => {
    let cartItems = localStorageFunc('get','','cart')
    if(!cartItems) return;
    cartItems = JSON.parse(cartItems)
    dispatch({type: Action.INITIALIZE_CART, payload: cartItems})
  }, [])
  return (
    <div>
      <Backdrop
        show={loading}
        element={<Loader />}
        style={{ background: 'rgba(255, 255, 255, 0.7)' }}
      />
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<Homepage />} />

          <Route path='contact' element={<Contact />} />
          <Route path='about' element={<About />} />
          <Route path='menu' element={<Menu />}>
            <Route index element={<Main />} />
            <Route path=':id' element={<CategoryView />} />
          </Route>
          <Route path='cart' element={<Cart />} />
          <Route path='checkout' element={<Checkout />} />

          {state.auth.user && (
            <Route path='usersetting' element={<UserSetting />} />
          )}

          {state.auth.user && (
            <Route path='orderdetails' element={<OrderDetails />} />
          )}
        </Route>

        <Route path='login' element={<Login />} />
        <Route path='signup' element={<Signup />} />

        {/* ADMIN ROUTE IS ACCESSIBLE ONLY IF USER IS LOGGED IN AND THE USER ROLE IS ADMIN */}

        {state.auth.user && isAdmin(state.auth.user?.role) && (
          <Route path='admin' element={<LazyComponent component={<Admin />} />}>
            <Route index element={<Overview />} />
            <Route path='users' element={<Outlet />}>
              <Route index element={<Users />} />
              <Route path='edit/:id' element={<EditUser />} />
              <Route path=':id' element={<ViewUser />} />
            </Route>
            <Route path='products' element={<Outlet />}>
              <Route index element={<Products />} />
              <Route path='edit/:id' element={<EditProduct />} />
              <Route path=':id' element={<ViewProduct />} />
              <Route path='add' element={<AddProduct />} />
            </Route>
            <Route path='reservations' element={<Reservations />} />
            <Route path='orders' element={<Order />} />
            <Route path='settings' element={<Settings />} />
          </Route>
        )}
        {/* <Route path='/*' element={<h2>404 Not Found</h2>} /> */}
      </Routes>
    </div>
  );
}

export default App;
